var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4173 23.3331C40.4178 19.8813 43.2165 17.0836 46.6683 17.0841C50.1201 17.0847 52.9178 19.8833 52.9173 23.3351C52.9168 26.7869 50.1181 29.5846 46.6663 29.5841L42.9165 29.5835V40.418L46.6663 40.4174C50.1181 40.4169 52.9168 43.2147 52.9173 46.6665C52.9178 50.1182 50.1201 52.9169 46.6683 52.9174C43.2165 52.918 40.4178 50.1202 40.4173 46.6684L40.4167 42.9166H29.5846L29.584 46.6684C29.5834 50.1202 26.7848 52.918 23.333 52.9174C19.8812 52.9169 17.0834 50.1182 17.084 46.6665C17.0845 43.2147 19.8832 40.4169 23.335 40.4174L27.0832 40.418V29.5835L23.335 29.5841C19.8832 29.5846 17.0845 26.7869 17.084 23.3351C17.0834 19.8833 19.8812 17.0847 23.333 17.0841C26.7848 17.0836 29.5834 19.8813 29.584 23.3331L29.5846 27.0833H40.4167L40.4173 23.3331ZM27.0846 27.0833L27.084 23.3335C27.0837 21.2624 25.4045 19.5838 23.3334 19.5841C21.2623 19.5844 19.5837 21.2636 19.584 23.3347C19.5843 25.4058 21.2635 27.0844 23.3346 27.0841L27.0846 27.0833ZM46.6679 19.5841C44.5968 19.5838 42.9176 21.2624 42.9173 23.3335L42.9167 27.0835L46.6667 27.0841C48.7378 27.0844 50.417 25.4058 50.4173 23.3347C50.4176 21.2636 48.739 19.5844 46.6679 19.5841ZM29.5832 29.5833V40.4166H40.4165V29.5833H29.5832ZM50.4173 46.6668C50.417 44.5958 48.7378 42.9171 46.6667 42.9174L42.9167 42.918L42.9173 46.668C42.9176 48.7391 44.5968 50.4178 46.6679 50.4174C48.739 50.4171 50.4176 48.7379 50.4173 46.6668ZM19.584 46.6668C19.5843 44.5958 21.2635 42.9171 23.3346 42.9174L27.0846 42.918L27.084 46.668C27.0837 48.7391 25.4045 50.4178 23.3334 50.4174C21.2623 50.4171 19.5837 48.7379 19.584 46.6668Z",
    fill: "url(#paint0_linear_269_695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_695",
    x1: 35.0006,
    y1: 17.0841,
    x2: 35.0006,
    y2: 52.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon3);
export default __webpack_public_path__ + "static/media/con3.03e22a86c863d6f437f4457bc0da45a2.svg";
export { ForwardRef as ReactComponent };